export type Compra = {
  name: string
  city: string
  plan: 'Programa Atleta Corporativo' | 'Atleta Corporativo Élite'
  minutesAgo: number
}

export const compras: Compra[] = [
  {
    name: 'Martín G.',
    city: 'Buenos Aires',
    plan: 'Atleta Corporativo Élite',
    minutesAgo: 2,
  },
  {
    name: 'Laura P.',
    city: 'Rosario',
    plan: 'Programa Atleta Corporativo',
    minutesAgo: 6,
  },
  {
    name: 'Roberto M.',
    city: 'Córdoba',
    plan: 'Atleta Corporativo Élite',
    minutesAgo: 11,
  },
  {
    name: 'Cecilia R.',
    city: 'Mendoza',
    plan: 'Programa Atleta Corporativo',
    minutesAgo: 17,
  },
  {
    name: 'Sofía C.',
    city: 'La Plata',
    plan: 'Atleta Corporativo Élite',
    minutesAgo: 23,
  },
  {
    name: 'Pablo A.',
    city: 'Rosario',
    plan: 'Programa Atleta Corporativo',
    minutesAgo: 28,
  },
  {
    name: 'Diego F.',
    city: 'Tucumán',
    plan: 'Atleta Corporativo Élite',
    minutesAgo: 34,
  },
  {
    name: 'Valeria S.',
    city: 'Mar del Plata',
    plan: 'Programa Atleta Corporativo',
    minutesAgo: 41,
  },
]
